import { AuthEvent, AuthPayload } from 'services/auth/events/events';
import LazyWallet from 'services/auth/lazy-wallet';
import EventService from 'services/event.service';

export default class AuthServiceClass {
    event: EventService<AuthEvent, AuthPayload> = new EventService();

    private ledger = new LazyWallet(async () => {
        const { default: LedgerService } = await import('./ledger/ledger.service');
        return new LedgerService(this.event);
    });
    private walletConnect = new LazyWallet(async () => {
        const { default: WalletConnectService } =
            await import('./wallet-connect/wallet-connect.service');
        return new WalletConnectService(this.event);
    });
    private lobstrExtension = new LazyWallet(async () => {
        const { default: LobstrExtensionService } =
            await import('./lobstr-extension/lobstr-extension.service');
        return new LobstrExtensionService(this.event);
    });
    private walletKit = new LazyWallet(async () => {
        const { default: WalletKitService } = await import('./wallet-kit/wallet-kit.service');
        return new WalletKitService(this.event);
    });

    getLedger = () => this.ledger.load();
    getWalletConnect = () => this.walletConnect.load();
    getLobstrExtension = () => this.lobstrExtension.load();
    getWalletKit = () => this.walletKit.load();

    // Logout must never download or initialize an unused wallet SDK.
    logoutWalletKit = () => this.walletKit.current?.logout();
    logoutWalletConnect = async () => this.walletConnect.current?.logout();
}
